import { categories } from '@/mocks/categories';

export default function CategoryDropdown() {
  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const url = e.target.value;
    if (url) {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <section className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-2xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            Browse Product Categories
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-lg mx-auto">
            Select a category below to explore our full product range on the main store
          </p>
        </div>

        <div className="relative">
          <select
            onChange={handleChange}
            defaultValue=""
            className="w-full appearance-none bg-background-100 border-2 border-background-200 rounded-2xl px-5 py-4 pr-12 text-foreground-800 text-base font-medium cursor-pointer hover:border-primary-300 focus:border-primary-400 focus:outline-none focus:ring-4 focus:ring-primary-100 transition-all duration-200"
          >
            <option value="" disabled>Choose a category...</option>
            {categories.map((cat) => (
              <option key={cat.id} value={cat.url}>
                {cat.name}
              </option>
            ))}
          </select>
          <div className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none w-5 h-5 flex items-center justify-center">
            <i className="ri-arrow-down-s-line text-foreground-500 text-lg"></i>
          </div>
        </div>
      </div>
    </section>
  );
}